import { Component, Input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { SecurityPolicy } from 'src/app/models/security-policy';
import { HtmlEncodePipe } from 'src/app/pipes/html-encode.pipe';

@Component({
    selector: 'app-password-policy',
    imports: [TranslateModule, MatIcon, HtmlEncodePipe],
    templateUrl: './password-policy.component.html',
    styleUrl: './password-policy.component.scss'
})
export class PasswordPolicyComponent {
    @Input() securityPolicy: SecurityPolicy;

    constructor() {}
}
